import { Table, TableBody, TableContainer, TableHead, TableRow } from "@mui/material";
import { useSuperAdminSingleSuscrip } from "../../../../context/SuperAdmin/SingleSuscriptContext";
import { StyledTableCell } from "../../../../ui-components/StyledTables";
import ProfileRowCreditsSuscription from "./ProfileRowCreditsSuscription";

const CreditsSuscriptionsTable = () => {
  const { suscribedUsers } = useSuperAdminSingleSuscrip();

  return (
    <TableContainer
      sx={{
        width: "100%",
        margin: "auto",
        borderRadius: 2,
        overflow: "hidden",
      }}
    >
      <Table sx={{ minWidth: 500, width: "100%" }} aria-label="simple table">
        <TableHead sx={{ height: 20 }}>
          <TableRow>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              N°
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              Nombre
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              Apellido
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              Fecha de asignación
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              Créditos gastados
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              Estado
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {suscribedUsers.length > 0 ? (
            suscribedUsers.map((usuario, index) => (
              <ProfileRowCreditsSuscription
                usuario={usuario}
                i={index + 1}
                key={usuario.id_usuario}
              />
            ))
          ) : (
            <TableRow>
              <StyledTableCell
                colSpan={9}
                sx={{
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                }}
              >
                No hay campos aún
              </StyledTableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CreditsSuscriptionsTable;
